export class Answer {
	public id;
	public answerText;

	setAnswerData(data){
		this.id = data.id;
		this.answerText = data.value;
	}
}
